import { useTranslation } from 'react-i18next';

export function ValuesSection() {
  const { t } = useTranslation();

  const values = [
    {
      icon: 'ri-focus-line',
      title: t('about.values.list.0.title'),
      description: t('about.values.list.0.description'),
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: t('about.values.list.1.title'),
      description: t('about.values.list.1.description'),
    },
    {
      icon: 'ri-shield-check-line',
      title: t('about.values.list.2.title'),
      description: t('about.values.list.2.description'),
    },
    {
      icon: 'ri-rocket-line',
      title: t('about.values.list.3.title'),
      description: t('about.values.list.3.description'),
    },
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-black">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <div className="text-center mb-12">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            {t('about.values.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-gray-800 rounded-2xl border border-gray-700 p-8 text-center hover:border-yellow-400 hover:scale-105 transition-ball duration-300 shadow-xl"
            >
              <div className="flex justify-center mb-6">
                <div className="w-16 h-16 flex items-center justify-center bg-yellow-400/10 rounded-full">
                  <i className={`${value.icon} text-4xl text-yellow-400`}></i>
                </div>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">
                {value.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
